"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FallbackElevenLabsVoiceIdEnum = void 0;
exports.FallbackElevenLabsVoiceIdEnum = {
    Burt: "burt",
    Marissa: "marissa",
    Andrea: "andrea",
    Sarah: "sarah",
    Phillip: "phillip",
    Steve: "steve",
    Joseph: "joseph",
    Myra: "myra",
    Paula: "paula",
    Ryan: "ryan",
    Drew: "drew",
    Paul: "paul",
    Mrb: "mrb",
    Matilda: "matilda",
    Mark: "mark",
};
